"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var TokenRow_1 = require("./TokenRow");
var theme = require("./theme.scss");
var lib_1 = require("../../../../lib");
var TokensForm = /** @class */ (function (_super) {
    tslib_1.__extends(TokensForm, _super);
    function TokensForm(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.createTokenApi = function () {
            var createToken = _this.props.createToken;
            createToken();
        };
        _this.onDelete = function (token) {
            _this.setState({ promptDeleteItem: token });
        };
        _this.cancelDeleteItem = function () {
            _this.setState({ promptDeleteItem: null });
        };
        _this.deleteToken = function () {
            var deleteToken = _this.props.deleteToken;
            var promptDeleteItem = _this.state.promptDeleteItem;
            deleteToken(promptDeleteItem._id);
            _this.cancelDeleteItem();
        };
        _this.cancelNewToken = function () {
            var clearNewToken = _this.props.clearNewToken;
            clearNewToken();
        };
        _this.copyToClipboard = function () {
            var newTokenApi = _this.props.newTokenApi;
            lib_1.MemoryClipboard.copy(newTokenApi);
        };
        _this.state = { promptDeleteItem: null, clientSecret: "", clientId: "" };
        return _this;
    }
    TokensForm.prototype.renderTable = function () {
        var _this = this;
        var _a = this.props, tokens = _a.tokens, newTokenApi = _a.newTokenApi;
        var promptDeleteItem = this.state.promptDeleteItem;
        return (React.createElement("div", { className: theme.tokens },
            React.createElement(ui_1.Button, { iconName: "icon-plus-small", type: "button", medium: true, gray: true, onClick: this.createTokenApi }, "Create New Token"),
            React.createElement(ui_1.Table, { fill: true },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement(ui_1.TableHeaderColumn, { label: "Token" }),
                        React.createElement(ui_1.TableHeaderColumn, { label: "Created" }),
                        React.createElement(ui_1.TableHeaderColumn, { label: "Delete" }))),
                React.createElement("tbody", null, tokens.map(function (token) { return (React.createElement(TokenRow_1.default, { key: token._id, onDelete: _this.onDelete, token: token })); }))),
            React.createElement(ui_1.Modal, { external: true, exitOnClickOutside: true, onClose: this.cancelDeleteItem, isOpen: !!promptDeleteItem },
                React.createElement(ui_1.ConfirmPopMessage, { red: true, title: "Delete Token?", text: React.createElement("span", null,
                        "Are you sure you want to delete ",
                        promptDeleteItem ?
                            React.createElement(ui_1.Label, { weight: 600, block: false }, promptDeleteItem.startToken + "......" + promptDeleteItem.endToken) : "",
                        "?"), cancelText: "No, Cancel", confirmText: "Yes, Delete", onCancelClick: this.cancelDeleteItem, onConfirmClick: this.deleteToken })),
            React.createElement(ui_1.Modal, { external: true, exitOnClickOutside: true, onClose: this.cancelNewToken, isOpen: !!newTokenApi },
                React.createElement(ui_1.Surface, { className: theme.surface },
                    React.createElement(ui_1.FormInput, { value: newTokenApi, name: "newTokenApi", label: "New Token Api", fill: true }),
                    React.createElement("div", { className: "flex" },
                        React.createElement(ui_1.Button, { type: "button", medium: true, gray: true, uppercase: true, onClick: this.cancelNewToken }, "Close"),
                        React.createElement(ui_1.Button, { type: "button", medium: true, blue: true, uppercase: true, onClick: this.copyToClipboard }, "Copy Token"))))));
    };
    TokensForm.prototype.renderLoader = function () {
        return (React.createElement("div", { className: theme.message },
            React.createElement(ui_1.Loader, { size: 1, gray: true, className: theme.loader }),
            React.createElement(ui_1.PageMessage, { small: true, title: "Loading Tokens api", description: "Please wait..." })));
    };
    TokensForm.prototype.render = function () {
        var isLoadingTokensApi = this.props.isLoadingTokensApi;
        return (isLoadingTokensApi ? (this.renderLoader()) : this.renderTable());
    };
    TokensForm.defaultProps = {};
    return TokensForm;
}(React.Component));
exports.default = TokensForm;
